module.exports = __webpack_public_path__ + "static/media/lastmin.733a2c35.jpg";